import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/hitta-elbolag")({
  beforeLoad: () => permanentRedirect("/verktyg/hitta-elbolag"),
});
